import type { FormKitSchemaNode } from "@formkit/core";

/**
 * Wraps schema nodes in section card with repeater controls.
 * Relies on being the child node of a repeater input.
 */
export function wrapInRepeaterSectionCard(
	children: FormKitSchemaNode[],
): FormKitSchemaNode {
	return {
		$cmp: "SectionCard",
		props: {
			heading: "$label",
			subHeading: "$node.parent.context.label",
			actions: {
				add: {
					icon: "add",
					execute: "$node.parent.context.fns.createInsert($index)",
					disabled: "$node.parent.value.length >= $node.parent.props.max",
					label: "$: 'Voeg ' + $label + ' toe",
				},
				remove: {
					icon: "delete",
					execute: "$node.parent.context.fns.createRemover($index)",
					disabled: "$node.parent.value.length <= $node.parent.props.min",
					label: `$: 'Verwijder ' + $node.parent.context.label + ' (' + ($index + 1) + ')'`,
				},
			},
		},
		children,
	};
}

/**
 * Wraps schema nodes in section card.
 */
export function wrapInSectionCard(
	children: FormKitSchemaNode[],
): FormKitSchemaNode {
	return {
		$cmp: "SectionCard",
		props: {
			heading: "$label",
			actions: {},
		},
		children,
	};
}

/**
 * Wraps schema nodes in section card with controls for optional group.
 * Relies on being the child node of optional group component.
 */
export function wrapInOptionalSectionCard(
	children: FormKitSchemaNode[],
): FormKitSchemaNode {
	return {
		$cmp: "SectionCard",
		props: {
			heading: "$label",
			actions: {
				remove: {
					icon: "delete",
					execute: "$node.context.fns.disableGroup",
					label: `$: 'Verwijder ' + $node.context.label`,
				},
				add: {
					icon: "add",
					execute: "() => {}",
					disabled: true,
					label: "$: 'Voeg ' + $label + ' toe",
				},
			},
		},
		children,
	};
}
